// src/services/axiosInstance.js

import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { AuthStorage } from './AuthStorage';

const axiosInstance = axios.create({
	baseURL: API_BASE_URL
});

axiosInstance.interceptors.request.use(
	(config) => {
		const token = AuthStorage.getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		// Optionally handle 401 responses globally
		// if (error.response && error.response.status === 401) {
		//   AuthStorage.removeToken();
		// }
		return Promise.reject(error);
	}
);

export default axiosInstance;
